import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { FiAward, FiArrowRight } from "react-icons/fi";
import scholarshipService from "../services/scholarshipService";
import { useApp } from "../context/AppContext";

export default function ScholarshipSummaryWidget() {
    const { academicYear } = useApp();
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!academicYear?._id) return;
        (async () => {
            setLoading(true);
            try {
                const res = await scholarshipService.getSummary(academicYear._id);
                setSummary(res.data);
            } catch (err) {
                setSummary(null);
            } finally {
                setLoading(false);
            }
        })();
    }, [academicYear?._id]);

    if (!academicYear?._id) return null;

    return (
        <div className="card">
            <div className="card-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <strong style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                    <FiAward size={15} />
                    Scholarships — {academicYear.label}
                </strong>
                <Link to="/scholarships" style={{ fontSize: 12.5, display: "flex", alignItems: "center", gap: 3 }}>
                    View all <FiArrowRight size={11} />
                </Link>
            </div>
            <div className="card-body">
                {loading ? (
                    <div className="loading-center">
                        <div className="spinner" />
                    </div>
                ) : !summary || summary.studentCount === 0 ? (
                    <p style={{ fontSize: 13, color: "var(--text-muted)" }}>No scholarship records for this academic year yet.</p>
                ) : (
                    <>
                        <div style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                            <div>
                                <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase" }}>Sanctioned</div>
                                <div style={{ fontSize: 18, fontWeight: 700 }}>₹{summary.totalSanctioned.toLocaleString("en-IN")}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase" }}>Disbursed</div>
                                <div style={{ fontSize: 18, fontWeight: 700, color: "#16a34a" }}>
                                    ₹{summary.totalDisbursed.toLocaleString("en-IN")}
                                </div>
                            </div>
                            <div>
                                <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase" }}>Pending</div>
                                <div style={{ fontSize: 18, fontWeight: 700, color: "#b45309" }}>
                                    ₹{summary.totalPending.toLocaleString("en-IN")}
                                </div>
                            </div>
                            <div>
                                <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase" }}>Students</div>
                                <div style={{ fontSize: 18, fontWeight: 700 }}>{summary.studentCount}</div>
                            </div>
                        </div>

                        {summary.byScheme?.length > 0 && (
                            <div style={{ width: "100%", height: 180 }}>
                                <ResponsiveContainer>
                                    <BarChart data={summary.byScheme} margin={{ top: 4, right: 8, left: 0, bottom: 4 }}>
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                        <XAxis dataKey="schemeType" tick={{ fontSize: 11 }} />
                                        <YAxis tick={{ fontSize: 11 }} />
                                        <Tooltip formatter={(value) => `₹${value.toLocaleString("en-IN")}`} />
                                        <Bar dataKey="sanctioned" fill="#93c5fd" name="Sanctioned" radius={[4, 4, 0, 0]} />
                                        <Bar dataKey="disbursed" fill="#34d399" name="Disbursed" radius={[4, 4, 0, 0]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}